module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6IX9C"))).then(() => parcelRequire('dJXJK'));